import {
  Component,
  EventEmitter,
  Output,
  effect,
  model,
  signal,
} from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { LanguageService } from '@shared/services/language.service';
import { TreeNode } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { TreeModule } from 'primeng/tree';

@Component({
  selector: 'app-dialog-filter-category-tree',
  templateUrl: './category-modal.component.html',
  styleUrls: ['./category-modal.component.scss'],
  standalone: true,
  imports: [ButtonModule, TreeModule, FaIconComponent, TranslatePipe],
})
@UntilDestroy()
export class CategoryTreeDialog {
  label = model<string>();

  @Output('onCallback') onCallback: EventEmitter<TreeNode[]> =
    new EventEmitter();

  treeCategories = signal<TreeNode[]>([]);
  selectedCategories = signal<TreeNode[]>([]);
  selectedNode = model<TreeNode>(this.selectedCategories()?.[0]);
  auctionsCount = model<number>();

  constructor(
    readonly translateService: TranslateService,
    public activeModal: NgbActiveModal,
    readonly languageService: LanguageService
  ) {
    effect(
      () => {
        this.selectedNode.set(this.selectedCategories()?.[0]);
      },
      {
        allowSignalWrites: true,
      }
    );
  }

  flattenTree(node: TreeNode): TreeNode[] {
    const nodes = [node];
    if (node.children) {
      for (const child of node.children) {
        nodes.push(...this.flattenTree(child));
      }
    }
    return nodes;
  }

  onNodeSelect(node: TreeNode) {
    this.selectedCategories.set(this.flattenTree(node));
    this.selectedNode.set(node);

    this.onCallback.emit(this.selectedCategories());
  }

  onSelectAll() {
    this.selectedNode = null;
    this.onCallback.emit([]);
  }

  toggleDropdown(node: TreeNode) {
    node.data.expanded = !node.data.expanded;
  }
}
